import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import React, { useEffect, useMemo, useState } from 'react';
import SurveyContainer from './SurveyContainer';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import {
  Alert,
  Button,
  Container,
  Stack,
} from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { useNavigate } from 'react-router-dom';
import { hwndjs } from 'utils/hwnd';
import { formInformation } from 'Routes/Public/Survey/functions/formInformation';
import { SaveSurveyForm } from 'Routes/Public/Survey/adapters/SaveSurveyForm';
import useGatherDataFromApi from 'Global/Hooks/useGatherDataFromApi';
import { EditFormValueNormlizer } from 'Global/Components/Generators/FormElementCreatorByType/Functions/EditFormValueNormlizer';
import EditGroupedView from 'Global/Components/EditableComponents/EditableGroupedView/EditGroupedView';
import { functionArray } from 'Routes/Public/Survey/variables/functionArray';
import { useAtom } from 'jotai';
import { surveyDisableEditAtom } from 'Global/shared/survey.disabel.edit.atom';
import { Check, CheckCircle } from '@mui/icons-material';
import i18next from 'i18next';

const Survey = ({ survey,index }) => {
  const [formEnabled, setFormEnabled] = useState(false);

  const [surveryData, setSurveyData] = useState([]);
  const [s, setSurveyDisable] = useAtom(
    surveyDisableEditAtom
  );

  const fillForm_label = FindLangKey(
    'general-public-btn-name-fill-form'
  );

  const viewForm_label = FindLangKey(
    'general-public-preview'
  );

  const navigate = useNavigate();

  const { patientID, idConfer, idType, formID } =
    formInformation(
      survey?.SurveyLink?.split('keyConfer=')[1]
    );
  const IdFormPatient = survey?.IdFormPatient;

  const dataArray = functionArray(
    patientID,
    idConfer,
    idType,
    formID,
    IdFormPatient
  );

  // console.log('-->', {
  //   patientID,
  //   idConfer,
  //   idType,
  //   formID,
  //   patientFormID,
  // });

  // console.log('patientFormIDpatientFormID--->', {
  //   survey,
  //   IdFormPatient,
  // });

  useEffect(() => {
    if (surveryData.length > 0) {
      SaveSurveyForm(
        { patientID, idConfer, idType, formID },
        surveryData,
        navigate
      );
    }
  }, [surveryData]);

  useEffect(() => {
    if (IdFormPatient === 0) {
      setSurveyDisable(IdFormPatient);
    } else {
      setSurveyDisable(IdFormPatient);
    }
  }, [IdFormPatient]);

  // console.log('IdFormPatient--->', IdFormPatient);
  // console.log('ssssssssssssssss--->', s);

  const { gatheredData } = useGatherDataFromApi(
    dataArray,
    null,
    false,
    formEnabled
  );

  const memoFormData = useMemo(
    () => gatheredData,
    [JSON.stringify(gatheredData), IdFormPatient]
  );

  const NazarSanjiDefaultValues =
    EditFormValueNormlizer(memoFormData);

  const isNoData = [
    patientID,
    idConfer,
    idType,
    formID,
  ].every((item) => item === null || item.length === 0);

  const notFoundMsg = FindLangKey(
    'general-public-flat-alert-no-data'
  );


  console.log('memoFormData--->',memoFormData)

   
  return (
    <React.Fragment>
      {isNoData ? (
        <Alert
          dir={i18next.language === 'en' ? 'ltr' : 'rtl'}
          severity="info"
        >
          {notFoundMsg}
        </Alert>
      ) : (
        <FrameCard
          cardProps={{
            p: '.3em',
            borderRadius: '20px',
          }}
          jsx={
            <SurveyContainer>
              {IdFormPatient > 0 ? (
                <CheckCircle color="success" />
              ) : (
                <></>
              )}
              <p>{survey?.DateReception}</p>
              {survey?.DoctorName?.trim()?.length === 0 ? (
                <p>
                  {ArabicToPersian(survey?.NameDepartment)}
                </p>
              ) : (
                <p>{ArabicToPersian(survey?.DoctorName)}</p>
              )}
              {/* <Button
      variant="contained"
      sx={{
        color: `${themeColors.ColorPrimary} !important`,
        textAlign: 'center',
        maxWidth: '95%',
      }}
      onClick={() => {
        setFormEnabled((prev) => !prev);
      }}
    >
      {survey?.NameForm}
    </Button> */}

              <React.Fragment>
                <Container>
                  <Stack mt=".5em" gap=".5em">
                    {!formEnabled ? (
                      <EditGroupedView
                        StateBank={{
                          ...memoFormData,
                          formId: formID,
                          title: `test-${index}`,
                        }}
                        fieldArrayName={
                          'MedicalDefaultValues'
                        }
                        DefaultValues={
                          NazarSanjiDefaultValues
                        }
                        isSurvey={true}
                        liftState={setSurveyData}
                        surveyDisable={IdFormPatient}
                      />
                    ) : (
                      <></>
                    )}
                  </Stack>
                  <br />
                </Container>
              </React.Fragment>
            </SurveyContainer>
          }
        />
      )}
    </React.Fragment>
  );
};

export default Survey;
